import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const createPayment = async (postData:any) => {
    try {
  return await post<ApiResponse<[]>>('/trolley/recipient/payment', postData).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){
HandleApiError(e)
}
};
